import { render, staticRenderFns } from "./DispatchRequestStatus.vue?vue&type=template&id=c0061fd4&"
import script from "./DispatchRequestStatus.vue?vue&type=script&lang=js&"
export * from "./DispatchRequestStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports